import { ACTIVATE_CONSUMER_ENROLLMENT } from '../actions/types';

export default function(state = null, action) {
  switch (action.type) {
    case ACTIVATE_CONSUMER_ENROLLMENT:
      return action.payload
    default:
      return state;
  }
}